import axios from 'axios';
import Home from './main-views/Home';
import ViewArticle from './views/ViewArticle';
import ViewStory from './views/ViewStory';
import Account from './main-views/Account';
import MySubscription from './views/MySubscription';
import BuySubscriptionPackage from './views/BuySubscriptionPackage'
import Dating from './main-views/Dating';
import FindMatch from './views/FindMatch';
import ChatRoom from './views/ChatRoom';
import Doctors from './main-views/Doctors';
import PersonalInfoUpdateWidget from './ones/PersonalInfoUpdateWidget';
import { STR_UPDATE_PERSONAL_INFO } from './Strings';
import BuyDoctorRoom from './views/BuyDoctorRoom';
import Inbox from './main-views/Inbox';
import Notifications from './main-views/Notifications';
import ChangePhone from './views/ChangePhone';
import LoginView from './views/LoginView';
import ContactUs from './views/ContactUs';
import ContentCommentor from './views/ContentCommentor';
import ViewConfession from './views/ViewConfession';
import ViewPharmacyItem from './views/ViewPharmacyItem';
import Pharmacy from './main-views/Pharmacy';
import PharmacyCheckout from './views/PharmacyCheckout';
import PharmacyCart from './views/PharmacyCart';
import Fitness from './main-views/Fitness';
import ChitChat from './main-views/ChitChat';
import ViewPharmacyOrder from './views/ViewPharmacyOrder';
import PharmacyOrderPayment from './views/PharmacyOrderPayment';


export const BASE_API = 'https://afyamingle.werenium.com/api/';
//export const BASE_API = 'https://afyamingle.werenium.com/api/';

export const CDN_URL = 'https://afyamingleapp.werenium.com/cdn/'
//export const CDN_URL = 'https://afyamingleapp.werenium.com/cdn/'

export const WEB_SOCKET_URL = 'wss://afyamingle.werenium.com'

export function getMainView(app) {
  if (app.navItem === 'home' || !app.navItem) {
    return <Home />;
  } else if (app.navItem === 'account') {
    return <Account />;
  } else if (app.navItem === 'dating') {
    return <Dating />;
  } else if (app.navItem === 'doctors') {
    return <Doctors />;
  } else if (app.navItem === 'inbox') {
    return <Inbox />;
  } else if (app.navItem === 'notifications') {
    return <Notifications />;
  } else if (app.navItem === 'pharmacy') {
    return <Pharmacy />;
  } else if (app.navItem === 'fitness') {
    return <Fitness />;
  } else if (app.navItem === 'chitchat') {
    return <ChitChat />;
  }

  return null;
}


export function getViewerView(app) {
  if (
    app.navSubItem === 'article' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewArticle id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'story' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewStory id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'confession' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewConfession id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'pharmacy-item' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewPharmacyItem id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'my-subscription' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <MySubscription />;
  } else if (
    app.navSubItem === 'find-match' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <FindMatch />;
  } else if (
    app.navSubItem === 'chatroom' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ChatRoom participantId={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'update-personal-info' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <div className='container'>
        <PersonalInfoUpdateWidget title={STR_UPDATE_PERSONAL_INFO[app.language]} />
      </div>
    );
  } else if (
    app.navSubItem === 'change-phone' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return (
      <ChangePhone/>
    );
  } else if (
    app.navSubItem === 'login' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <LoginView />;
  } else if (
    app.navSubItem === 'contact-us' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContactUs />;
  } else if (
    app.navSubItem === 'pharmacy-cart' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PharmacyCart />;
  } else if (
    app.navSubItem === 'pharmacy-order-payment' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PharmacyOrderPayment id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'pharmacy-order' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewPharmacyOrder id={app.navExtraItem}/>;
  }

  return null;
}

export function getSideViewerView(app) {
  if (
    app.navSubItem === 'pharmacy-order' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ViewPharmacyOrder id={app.navExtraItem}/>;
  }

  return null;
}

export function getBottomViewerView(app) {

  if (
    app.navSubItem === 'buy-subscription-package' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <BuySubscriptionPackage id={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'buy-doctor-room' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <BuyDoctorRoom doctorId={app.navExtraItem} />;
  } else if (
    app.navSubItem === 'article-commentor' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContentCommentor id={app.navExtraItem} type="article"/>;
  } else if (
    app.navSubItem === 'confession-commentor' &&
    app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <ContentCommentor id={app.navExtraItem} type="confession"/>;
  } else if (
    app.navSubItem === 'pharmacy-item-checkout' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PharmacyCheckout type="item"/>;
  } else if (
    app.navSubItem === 'pharmacy-cart-checkout' &&
    !app.navExtraItem &&
    !app.navMoreItem
  ) {
    return <PharmacyCheckout type="cart"/>;
  }

  return null;
}


export function getInlineLoader() {
  return (
    <div className="Loader"></div>
  )
}

export function getInlineLoaderMin() {
  return (
    <div className="LoaderMin"></div>
  )
}

export function remove255(input) {
  if (input.startsWith('255')) {
    return '0' + input.slice(3);
  }
  return input;
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function callApi(url, params) {
  return new Promise(async resolve => {
    await getLocalUser().then(user => {
      //..
      //call main api
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }

      for (let key in user) {
        formData.append(key, user[key]);
      }

      axios.post(BASE_API + url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {

        console.log(url, response.data);

        resolve(response.data);
      }).catch(error => {
        resolve({
          status: 0,
          msg: "Network Connection Error",
        })
      })
      //..
    })

  })
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('userId');
    let userToken = getCookie('userToken');
    let userType = getCookie('userType');

    resolve({
      userId,
      userToken,
      userType,
    })


  })
}

export function generateRandomString(length = 6) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  cname = 'afya-mingle-user-'+cname;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  cname = 'afya-mingle-user-'+cname;
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if (num <= 1 && num >= -1) {
    return num;
  }

  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function (item) {
    return Math.abs(num) >= item.value; // Use absolute value of num
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}
